import { cn } from 'lib/utils';

/**
 * A light pink multiplied over a caregiver's photo (Figma « Masque C100 »), as
 * `background-blend-mode: multiply` would. Place it last inside the photo's
 * positioned, clipped container.
 */
function PhotoTint({ className }: { className?: string }) {
  return (
    <span
      aria-hidden
      data-slot="photo-tint"
      className={cn('pointer-events-none absolute inset-0 bg-photo-tint mix-blend-multiply', className)}
    />
  );
}

export { PhotoTint };
